import { mapState } from 'vuex';
import loadErgoModule from '~/app/mixins/loadErgoModule';

export default {

    delimiters: ['[%', '%]'],

    mixins: [loadErgoModule],

    inject: {
        itemId: {
            default: null
        }
    },

    props: {
        insurance   : Object,
        template    : String,
        variationId : {
            default: null
        }
    },

    data() {
        return {
            checkedInsurance    : null,
            isInsuranceChecked  : null,
            areTimespansVisible : false,
            forceShowInsurance  : false,
            overlayClose        : false,
            timeSpanId          : null,
            translations        : null,

        }
    },

    computed: {
        ...mapState({
            selectedInsurances : state => state.ergo.selectedInsurances,
            basketInsurances   : state => state.ergo.basketInsurances,
            ergoOrderProp      : state => state.ergo.ergoOrderProp,
            basket             : state => state.basket
        }),
        variation() {
            return this.$store.getters[this.itemId + '/currentItemVariation'];
        },
        getSelectedTimePeriod() {

            if(this.timeSpanId) {

                let insurance = this.insurance.insurances.find(_insurance => _insurance.matrix.ergo_id === this.timeSpanId);

                if(insurance) {
                    return insurance.time_period.timeperiod_title_de
                }
            }

            return '';
        },
        insuranceTitle() {

            if(this.translations === null) {
                return this.insurance.insurance_type_info.title;
            }

            if(this.insurance.insurance_type_info.title === 'Ger&auml;teschutz') {
                return this.translations.ergoDeviceProtection;
            }
            if(this.insurance.insurance_type_info.title === 'Garantie-Verl&auml;ngerung') {
                return this.translations.ergoAdditionalWarranty;
            }

            return this.insurance_type_info.title;
        }
    },

    watch: {
        checkedInsurance: function (newValue) {

            this.setSelectedInsurance();

            if(newValue !== null) {
                this.areTimespansVisible = true;
                this.timeSpanId = newValue;
            }
        },
        isInsuranceChecked: function () {
            this.insuranceCheckedAction();
        },
        basketInsurances: function (newValue, oldValue) {

            if (newValue.length < oldValue.length || newValue.length === 0) {
                return false; // Insurance removed. Do nothing
            }

            let addedInsurance = newValue[newValue.length - 1];

            if (addedInsurance.ergo_insurance_type_id == this.insurance.insurance_type.ergo_id) {
                this.overlayClose = true;
            }
        },
        selectedInsurances: {
            handler() {
                this.selectedInsurance();
            },
            deep: true,
        }
    },

    created: function () {
        this.$store.commit('ergoSetItemId', this.itemId);
        // this.$options.template = this.template;
    },

    mounted() {
        this.setErgoOrderProp();
        this.translations = JSON.parse(document.getElementById('ergo--json__translations').innerHTML);
    },

    methods: {

        removeBasketInsurance($event) {

            if (!this.getInsuranceInBasket()) {
                throw new Error('Cannot find the basket item to remove the insurance from.');
            }

            this.$store.dispatch("removeErgoBasketInsurance", this.getInsuranceInBasket());
        },
        addBasketInsurance($event) {

            if (this.getInsuranceInBasket()) {
                throw new Error('Cannot add this insurance since the corresponding basket item already has it.');
            }

            let basketItem = this.$parent.getBasketItem();

            if (!basketItem) {
                throw new Error('Could not find a basket item for this insurance');
            }

            this.$store.dispatch("addErgoBasketInsurance", {
                id:                            null,
                basket_id:                     this.basket.data.id,
                basket_item_id:                basketItem.id,
                quantity:                      basketItem.quantity,
                ergo_insurance_type_id:        parseInt(this.insurance.insurance_type.ergo_id),
                ergo_insurance_time_period_id: parseInt(this.checkedInsurance),
            });

            this.overlayClose = true; // Enabled the overlay to display a confirmation of purchase
        },
        setSelectedInsurance() {

            if (!this.checkedInsurance) {
                return
            }

            let selectedInsurance = {};
            selectedInsurance.ergoInsuranceTypeId = this.insurance.insurance_type.ergo_id;
            selectedInsurance.ergoInsuranceTimePeriodId = this.checkedInsurance;

            if (!this.isInsuranceChecked && this.checkedInsurance) {
                this.isInsuranceChecked = this.insurance.insurance_type.ergo_id;
            }

            if (this.selectedInsurances.length === 0) {

                this.selectedInsurances.push(selectedInsurance);
                this.$store.dispatch("setSelectedInsurance", this.selectedInsurances);

            } else {

                let found = false;

                this.selectedInsurances.forEach(function (insurance) {
                    if (insurance.ergoInsuranceTypeId === selectedInsurance.ergoInsuranceTypeId) {
                        insurance.ergoInsuranceTimePeriodId = selectedInsurance.ergoInsuranceTimePeriodId;
                        found = true;
                    }
                });

                if (!found) {
                    this.selectedInsurances.push(selectedInsurance);
                }
            }

            this.$store.dispatch("setSelectedInsurance", this.selectedInsurances);
        },
        insuranceCheckedAction() {

            if (!this.isInsuranceChecked) {
                this.checkedInsurance = null;
                let index = this.selectedInsurances.indexOf(this.selectedInsurances.find(item => item.ergoInsuranceTypeId === this.insurance.insurance_type.ergo_id));
                if (index >= 0) {
                    this.selectedInsurances.splice(index, 1);
                }
                this.$store.dispatch("setSelectedInsurance", this.selectedInsurances);
                this.areTimespansVisible = false;

            } else {

                if (this.selectedInsurances.length === 0) {

                    this.checkedInsurance = this.insurance.insurances[0].matrix.ergo_id;
                    this.areTimespansVisible = true;

                } else {

                    let found = false;
                    let insurance = this.insurance;

                    this.selectedInsurances.forEach(function (item) {
                        if (item.ergoInsuranceTypeId === insurance.insurance_type.ergo_id) {
                            found = true;
                        }
                    });

                    if (!found) {
                        this.checkedInsurance = this.insurance.insurances[0].matrix.ergo_id;
                        this.areTimespansVisible = true;
                    }
                }
            }
        },
        selectedInsurance() {

            let that  = this;
            let found = false;

            this.selectedInsurances.forEach(function (item) {
                if (item.ergoInsuranceTypeId === that.insurance.insurance_type.ergo_id) {
                    that.checkedInsurance = item.ergoInsuranceTimePeriodId;
                    found = true;
                }
            });

            if (!found) {
                this.checkedInsurance   = null;
                this.isInsuranceChecked = false;
            }
        },
        toggleTimeSpansVisible($event) {

            $event.preventDefault();

            this.areTimespansVisible = !this.areTimespansVisible;

            if(this.areTimespansVisible && !this.isInsuranceChecked && this.template === '#ergo-insurance-basket') {
                this.isInsuranceChecked = this.insurance.insurance_type.ergo_id;
            }

        },
        indexWhere(array, conditionFn) {
            return array.indexOf(array.find(conditionFn))
        },
        hasInsuranceInBasket() {
            // The IDs of all basket items that have been insured BY THIS COMPONENT'S INSURANCE
            let insuredBasketItemIds = this
                .basketInsurances // Basket insurances
                .filter(item => item.ergo_insurance_type_id == this.insurance.insurance_type.ergo_id) // Insured by this insurance
                .map(item => parseInt(item.basket_item_id)); // Grab just their itemIds

            // All basket items which have an insurance attached
            let insuredBasketItems = this.basket.items.filter(item => insuredBasketItemIds.indexOf(item.id) >= 0);

            return Boolean(insuredBasketItems.find(item => item.variationId == this.variationId));
        },
        /**
         * Goes through the list of basketInsurances and gets the one that
         * has been added to the current basket item
         *
         * WARNING: Only works in basket mode. Otherwise a basket item is not available
         */
        getInsuranceInBasket() {

            let basketItem = this.$parent.getBasketItem();
            let insurance  = this.insurance;

            if (!basketItem) {
                return false;
            }

            let correspondingBasketInsurance = this.basketInsurances.find(basketInsurance => {

                let sameInsurance  = basketInsurance.ergo_insurance_type_id == insurance.insurance_type.ergo_id;
                let sameBasketItem = basketInsurance.basket_item_id == basketItem.id

                return sameBasketItem && sameInsurance;
            });

            return correspondingBasketInsurance;
        },
        getCurrentlySelectedTimePeriod() {

            let currentInsuranceInBasket = this.getInsuranceInBasket();

            if (!currentInsuranceInBasket) {
                throw new Error('No insurance is currently in the basket');
            }

            return this.insurance.insurances.find(timespan => timespan.matrix.ergo_id == currentInsuranceInBasket.ergo_insurance_time_period_id);
        },
        //add order prop to split items in basket
        setErgoOrderProp() {

            if(this.template === '#ergo-insurance-small' || this.template === '#ergo-insurance-large') {

                const index = this.variation.properties.findIndex(property => property.property.id === this.ergoOrderProp);

                if (index === -1) {
                    this.variation.properties.push({
                        property: {
                            id    : this.ergoOrderProp,
                            names : {
                                name: 'ergo'
                            },
                            value             : 'ergo',
                            valueType         : 'text',
                            isOderProperty    : true,
                            isShownAtCheckout : false,
                            isShownOnItemList : false,
                            isShownOnItemPage : false,
                            surcharge         : 0
                        }
                    })
                }
            }
        }
    },

    filters: {
        round: function (value) {

            let number = parseFloat(value);

            if (typeof number !== 'number') {
                return number;
            }

            return number.toFixed(2);
        },
        germanNumberFormat: function (value) {
            return parseFloat(value).toString().replace('.', ',');
        }
    },
}
